import api from 'Application/api/api';

const moveTemplateDown = (id, cancelToken = null) =>
    api.post(`project-manager/templates/${id}/move-down`, {
        cancelToken,
    });

export default moveTemplateDown;
